import React, {Component} from 'react';
import * as R from 'ramda';

import hydrateAdminSession from 'js/admin_session';
import {queryMoodBoard} from 'js/graphql/queries/queryMoodBoard';

const {ContentType} = window.sn.enums;

export default class CampaignIntro extends Component {
    state = {moodBoardImages: [], isMoodBoardImagesLoading: false};

    componentDidMount() {
        this.getCampaignMoodBoardImages(this.props.campaignId);
    }

    getCampaignMoodBoardImages = async campaignId => {
        await hydrateAdminSession();

        this.setState({isMoodBoardImagesLoading: true});
        const moodBoardContent = await queryMoodBoard([campaignId]);
        this.setState({isMoodBoardImagesLoading: false});

        if (moodBoardContent.length > 0) {
            const moodBoardImages = moodBoardContent[0].images;

            if (moodBoardImages.length > 0) {
                this.setState({
                    moodBoardImages
                });
            }
        }
    };

    displayPrimaryImage() {
        const {samplePostFilename} = this.props;

        if (samplePostFilename) {
            const backgroundStyle = {
                backgroundImage: `url('${samplePostFilename}')`,
                backgroundSize: 'cover'
            };

            return (
                <a href={samplePostFilename} target="_blank" rel="noopener noreferrer">
                  <div className="primary-image-cover" style={backgroundStyle} />
                </a>
            );
        }
        return;
    }

    displaySecondaryContent() {
        const {samplePostImages, sampleVideoContent, campaignDisplayType} = this.props;

        const contentTypeVal = R.last(R.split('_', campaignDisplayType));

        if (
            R.equals(contentTypeVal, ContentType.IMAGE) &&
            !R.isNil(samplePostImages) &&
            !R.isEmpty(samplePostImages)
        ) {
            return R.pipe(
                R.reject(R.isNil),
                R.map(imageUrl => {
                    const samplePostImageBackgroundStyle = {
                        backgroundImage: `url('${imageUrl.url}')`,
                        backgroundSize: 'cover'
                    };

                    return (
                        <a
                            href={imageUrl.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            key={imageUrl.url}
                        >
                            <div
                                className="secondary-image"
                                style={samplePostImageBackgroundStyle}
                            />
                        </a>
                    );
                })
            )(samplePostImages);
        } else if (
            R.equals(contentTypeVal, ContentType.VIDEO) &&
            !R.isNil(sampleVideoContent) &&
            !R.isEmpty(sampleVideoContent)
        ) {
            return R.pipe(
                R.reject(R.isNil),
                R.map(video => (
                    <a href={video.url} target="_blank" rel="noopener noreferrer" key={video.url}>
                        <div className="secondary-image">
                            <video
                                src={video.url}
                                poster={video.thumbnail_url}
                                width="100%"
                                height="100%"
                            />
                        </div>
                    </a>
                ))
            )(sampleVideoContent);
        }

        return;
    }

    displayMoodBoardImages = () => {
        const {moodBoardImages} = this.state;

        return R.map(moodBoard => {
            const moodBoardImageBackgroundStyle = {
                backgroundImage: `url(${moodBoard})`,
                backgroundSize: 'cover'
            };

            return (
                <a href={moodBoard} target="_blank" rel="noopener noreferrer" key={moodBoard}>
                  <div className="primary-image-cover" style={moodBoardImageBackgroundStyle} />
                </a>
            );
        })(moodBoardImages);
    };

    renderSampleImages = (contentTypeVal, secondaryImagesCount) => {
        const {moodBoardImages, isMoodBoardImagesLoading} = this.state;

        if (moodBoardImages.length > 0) {
            return (
               <div className="campaign-section-image">
                    <p className="content-section-title">Primary Image</p>
                   {this.displayMoodBoardImages()}
                </div>
            );
        }
       
        return (
            isMoodBoardImagesLoading &&  <p className="no-image-text">{'Loading'}</p>
        );
    };

    render() {
        const {
            campaignName,
            campaignDisplayType,
            description,
            samplePostImages,
            sampleVideoContent,
            campaignId
        } = this.props;

        const contentTypeVal = R.last(R.split('_', campaignDisplayType));

        let secondaryImagesCount = 0;
        if (!R.isNil(samplePostImages)) {
            secondaryImagesCount = samplePostImages.length;
        } else if (!R.isNil(sampleVideoContent)) {
            secondaryImagesCount = sampleVideoContent.length;
        }

        return (
          <>
            <div className="campaign-section">

                {this.renderSampleImages(contentTypeVal, secondaryImagesCount)}

                <div className="campaign-section-desc">
                    <div className="campaing-section-desc-item">
                        <p className="content-section-title">Campaign Title</p>
                        <p>{campaignName}</p>
                    </div>
                </div>
            </div>

            <div className="campaign-section -dir-column">
                <p className="content-section-title">Creator Pitch</p>
                <p>{description || 'N/A'}</p>
            </div>
          
          </>
        );
    }
}



// WEBPACK FOOTER //
// ./components/verify_receipt_common/campaign_intro_details.js